import { removeFromStorage } from '../sessionStorageHelpers'

/**
 *
 * @param url - URL to redirect to
 * @description - Removes user from session storage and redirects to the given URL
 * @example
 * redirectToUrl('/login')
 *
 */
const redirectToExternalUrl = (url: string) => {
    removeFromStorage('user')
    location.replace(url)
}

export default redirectToExternalUrl
